import React, { useState, useEffect } from "react";
import Loading from "../../../../../Common/Loading/Loading";
import { Col, Row, Button } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as F5eDnsDefaultParametersService from "../../../../../../service/F5eDnsDefaultParametersService";
import { ErrorUnexpected, OperationSuccessfully } from "../../../../../../const/Messages";

const initialValues = {
  id: "",
  ignoredCasesLog: false,
  ignoredCasesIr21: false,
  view2g3gOnlyCheckWithIR21: false,
  view4gOnlyCheckWithIR21: false,
};

/**
  @author Guilherme Almeida
  @date 12/05/2021
 */
export default function F5eDnsDefaultParameters() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    F5eDnsDefaultParametersService.getF5eDnsDefaultParameters()
        .then((hlrDefault) => {
          setValues(hlrDefault);
          setLoading(false);
        })
        .catch(() => {
          history.push("/", { message: ErrorUnexpected, messageType: "error" });
        });
  }, []); // eslint-disable-line

  const schema = Yup.object().shape({});

  function handleSave(values, actions) {

    F5eDnsDefaultParametersService.update(values)
      .then(() => {
        history.push("/settings/report/template/edns/f5/default", { message: OperationSuccessfully, messageType: "success" });
      })
      .catch((error) => {
        if (!error || !error.response || !error.response.data) {
          actions.setFieldError("view2g3gOnlyCheckWithIR21", ErrorUnexpected);
        } else if (error.response.data.title) {
          actions.setFieldError("view2g3gOnlyCheckWithIR21", error.response.data.title);
        }
        actions.setSubmitting(false);
      });
  }

  if (loading) {
    return <Loading />;
  }

  return (
    <Row>
      <Col>
        <div className="ibox">
          <div className="ibox-title">
            <h5>F5 eDNS Default Parameters</h5>
          </div>
          <div className="ibox-content">
            <Formik initialValues={values} validationSchema={schema} onSubmit={handleSave}>
              {() => (
                <Form>
                  <div className="font-weight-bold pt-2 pb-2"><label>GENERAL</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="ignoredCases"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      Ignored Cases:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesLog"/>
                          <label className="form-check-label pl-2">
                            Ignore value from LOG.
                          </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesLog" />
                        </span>
                      </div>
                      <div className="d-flex align-items-baseline">
                        <Field type="checkbox" name="ignoredCasesIr21" />
                        <label className="form-check-label pl-2">
                          Ignore value from IR21.
                        </label>
                        <span className="text-danger">
                          <ErrorMessage name="ignoredCasesIr21" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2"><label>2G/3G</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="view2g3gOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="view2g3gOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="view2g3gOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="hr-line-dashed"></div>
                  <div className="font-weight-bold pt-2 pb-2"><label>4G</label></div>
                  <div className="form-group row">
                    <label
                      htmlFor="view4gOnlyCheckWithIR21"
                      className="col-form-label col-sm-12 col-md-4 col-lg-4 col-xl-3 col-xxl-1"
                    >
                      IR.21:
                    </label>
                    <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4">
                      <Field type="checkbox" name="view4gOnlyCheckWithIR21" />
                      <label className="form-check-label pl-2">
                        Check fields only if IR21 file exists.
                      </label>
                      <span className="text-danger">
                        <ErrorMessage name="view4gOnlyCheckWithIR21" />
                      </span>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end">
                    <Link className="mr-1 btn btn-primary" to="/settings">
                      Cancel
                    </Link>
                    <Button variant="primary" type="submit">
                      Update
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </Col>
    </Row>
  );
}
